import React from 'react';

import { CardAuth, LoginForm } from '../../components';

export const SignInPage = () => {
  return (
    <CardAuth title='Đăng nhập'>
      <LoginForm
        resetLink='/reset-password-form'
        createAccountLink='/register-form'
      />
    </CardAuth>
  );
};
